import React from 'react';
import { Route } from 'react-router-dom';
import ExtractGeneral from './extractGeneral';
// import NewsDetail from './newsDetail';

export default (
  <Route path="/homepage/extrato/extratos-totais" component={ExtractGeneral} />
);
